// extracted by mini-css-extract-plugin
export default {"reportStatusSection":"LabsInboxSettingsContainerProcessingStatus_reportStatusSection__nqSG5"};